import { useState } from "react";
import axios from "axios";
import _ from "lodash";
import * as api from "../api";
import { useAppSelector } from "../store/hook";
import type {
  IUploadFileParams,
  IUploadSignedUrlResponse,
} from "../api/files";

interface UploadArgs {
  portalId: string;
  file: File;
  partialPayload: Partial<IUploadFileParams>;
}

export interface UploadedFile {
  id: string;
  key: string;
  name: string;
  s3_name: string;
  size: number;
}

export const useFileUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { contactId } = useAppSelector(
    (state) => state.portal || ({} as any)
  );

  const upload = async ({
    portalId,
    file,
    partialPayload,
  }: UploadArgs): Promise<UploadedFile> => {
    setUploading(true);
    setProgress(0);

    try {
      const params: IUploadFileParams = {
        path: "/",
        ...partialPayload,
        name: file.name,
        size: file.size,
        type: file.type,
        item_id: _.uniqueId("file-"),
        category_id: partialPayload.category_id || "",
        customer_id: contactId,
      };

      const res = await api.files.getUploadSignedUrl(portalId, [params]);
      console.log("signedUrls", { res });
      const signedUrlData: IUploadSignedUrlResponse | undefined = _.find(
        res.data,
        (s) => s.item_id === params.item_id
      );

      if (!signedUrlData?.url) throw new Error("Failed to get upload URL");

      await axios.put(signedUrlData.url, file, {
        headers: {
          "Content-Type": file.type,
          "x-file-upload-header": "file_upload",
        },
        onUploadProgress: (evt) => {
          if (evt.total) {
            setProgress(Math.round((evt.loaded / evt.total) * 100));
          }
        },
      });

      return signedUrlData.file;
    } finally {
      setUploading(false);
    }
  };

  return { upload, uploading, progress };
};
